import React, { useContext } from 'react';

import { context } from '../../../../components/Theme/Context';

function KobaiDefaultLogo() {
  const theme = useContext(context);

  return !theme.useCustomTheme ? (
    <header className={'tw:w-full tw:flex tw:flex-col tw:items-center tw:pb-8 tw:relative tw:z-1'}>
      <img src={theme.logos.company} alt="company logo" width="150" />
    </header>
  ) : (
    <></>
  );
}

export default KobaiDefaultLogo;
